import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Container,
  Segment,
  Table,
  Dimmer,
  Loader,
  Pagination,
  Modal,
  Popup,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { addOutletSlotAction, getOutletsAction } from 'state/business/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';

const mapStateToPropsOutletList = ({ business }) => ({
  outlets: business.outlets,
  loadingOutlets: business.loadingOutlets,
  allBusiness: business.allBusiness,
});

const OutletList = connect(mapStateToPropsOutletList)(props => {
  const { dispatch, outlets, loadingOutlets, allBusiness } = props;
  const currBusinessId = allBusiness.data[allBusiness.activeIndex].id;
  const [outletListModal, setOutletListModal] = useState({
    payload: null,
    confirm: { isOpen: false },
  });

  useEffect(() => {
    const payload = {
      businessId: currBusinessId,
      page: 1,
      size: 10,
    };
    if (!outletListModal.confirm.isOpen) dispatch(getOutletsAction(payload));
  }, [currBusinessId, dispatch, outletListModal.confirm.isOpen]);

  let paging = null;
  if (outlets) {
    paging = outlets.paging;
  }
  let totalPages = 0;
  if (paging) totalPages = Math.ceil(paging.total / paging.size);

  const handleOnPageChange = (_, val) => {
    const { activePage } = val;
    const payload = {
      businessId: allBusiness.data[allBusiness.activeIndex].id,
      page: activePage,
      size: 10,
    };
    dispatch(getOutletsAction(payload));
  };

  const handleAddOutletSlot = () => {
    setOutletListModal({
      ...outletListModal,
      confirm: { ...outletListModal.confirm, isOpen: false },
    });
    const payload = {
      businessId: allBusiness.data[allBusiness.activeIndex].id,
    };
    dispatch(addOutletSlotAction(payload));
  };
  const handleOpenConfirmModal = () => {
    const payload = {
      businessId: currBusinessId,
      page: 1,
      size: 99999999,
    };
    dispatch(getOutletsAction(payload));
    setOutletListModal({
      ...outletListModal,
      confirm: { ...outletListModal.confirm, isOpen: true },
    });
  };
  const handleCloseConfirmModal = () => {
    setOutletListModal({
      ...outletListModal,
      confirm: { ...outletListModal.confirm, isOpen: false },
    });
  };
  const convertDate = payloadDate => {
    const dateTimeFormat = new Intl.DateTimeFormat('id', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    const date = new Date(payloadDate);
    return dateTimeFormat.format(date);
  };

  let mxExpirationDate = null;
  if (outlets.data)
    outlets.data.outlets.forEach(outlet => {
      const expiredTime = new Date(outlet.end_date);
      if (!mxExpirationDate) mxExpirationDate = expiredTime;
      if (expiredTime.getTime() > mxExpirationDate.getTime())
        mxExpirationDate = expiredTime;
    });

  const isDateAfterToday = date => {
    const currDate = Date.now();
    const givenDate = new Date(date).getTime();

    return currDate <= givenDate;
  };

  return (
    <Container
      style={{ overflowY: 'scroll', maxHeight: '50vh', padding: '1vh' }}
    >
      {/* confirm modal  */}
      <Modal size="small" open={outletListModal.confirm.isOpen}>
        <Modal.Header style={{ background: '#d9534f', color: 'white' }}>
          <strong>Confirm</strong>
        </Modal.Header>
        <Modal.Content>
          <p>Are you sure you want to add new outlet slot?</p>
          <br />
          <p>
            NB: This outlet slot&apos;s expired date is{' '}
            {convertDate(mxExpirationDate)} and it will can no longer being used
            anymore if the slot is expired
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button style={{ color: '#333' }} onClick={handleCloseConfirmModal}>
            Cancel
          </Button>
          <Button
            style={{ background: '#d9534f', color: 'white' }}
            onClick={handleAddOutletSlot}
          >
            Update
          </Button>
        </Modal.Actions>
      </Modal>
      <SemanticToastContainer />
      <h3>OUTLET LIST</h3>
      {outlets.data ? (
        <>
          <p style={{ 'white-space': 'pre-wrap' }}>
            Total of the outlet being created (regardless exp or active){'\t'}:{' '}
            {outlets.paging.total}
            {'\n'}
            Total of active outlets{'\t\t\t\t\t\t\t\t\t\t\t'}:{' '}
            {outlets.data.active_outlets}{' '}
          </p>
        </>
      ) : (
        <></>
      )}
      {allBusiness.data ? (
        <>
          {!isDateAfterToday(
            allBusiness.data[allBusiness.activeIndex].expired_at
          ) ||
          allBusiness.data[allBusiness.activeIndex].billing_cycle ===
            'FTMM - Free Trial Moka Monthly' ? (
            <Popup
              content={
                !isDateAfterToday(
                  allBusiness.data[allBusiness.activeIndex].expired_at
                )
                  ? 'Business is expired'
                  : 'The account is in trial mode'
              }
              trigger={
                <span>
                  <Button color="blue" disabled content="Add Outlet Slot" />
                </span>
              }
            />
          ) : (
            <Button color="blue" onClick={handleOpenConfirmModal}>
              Add Outlet Slot
            </Button>
          )}
        </>
      ) : (
        <></>
      )}

      <Segment style={{ padding: '0px' }}>
        <Dimmer active={loadingOutlets}>
          <Loader size="massive">Loading</Loader>
        </Dimmer>
        <Table celled selectable style={{ margin: '0px' }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ID</Table.HeaderCell>
              <Table.HeaderCell>Outlet Name</Table.HeaderCell>
              <Table.HeaderCell>Created At</Table.HeaderCell>
              <Table.HeaderCell>Expired Date</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {outlets.data ? (
              outlets.data.outlets.map(outlet => {
                let keys = '';
                Object.keys(outlet).forEach(key => {
                  keys += outlet[key];
                });

                return (
                  <Table.Row key={keys}>
                    <Table.Cell key={`${keys}ID`}>{outlet.id}</Table.Cell>
                    <Table.Cell key={`${keys}name`}>{outlet.name}</Table.Cell>
                    <Table.Cell key={`${keys}createdAt`}>
                      {convertDate(outlet.created_at)}
                    </Table.Cell>
                    <Table.Cell key={`${keys}expiredAt`}>
                      {convertDate(outlet.end_date)}
                    </Table.Cell>
                    <Table.Cell key={`${keys}status`}>
                      {isDateAfterToday(outlet.end_date) ? (
                        <p style={{ color: 'green' }}>Active</p>
                      ) : (
                        <p style={{ color: 'red' }}>Expired</p>
                      )}
                    </Table.Cell>
                  </Table.Row>
                );
              })
            ) : (
              <></>
            )}
          </Table.Body>
          {paging ? (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="7">
                  <Pagination
                    activePage={paging.page}
                    totalPages={totalPages}
                    onPageChange={handleOnPageChange}
                    size="mini"
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          ) : (
            <></>
          )}
        </Table>
      </Segment>
    </Container>
  );
});

OutletList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  outlets: PropTypes.object.isRequired,
  loadingOutlets: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
};

export default OutletList;
